import Vue from 'vue'
import VueRouter from 'vue-router'
import login from "@/store/login";
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    meta:{title:"首页",isShow:true},
    component: () => import(/* webpackChunkName: "about" */ '../views/HomeView.vue')
  },
  {
    path: '/measuring',
    name: 'measuring',
    meta:{title:"测徒者V8",isShow:true},
    component: () => import(/* webpackChunkName: "about" */ '../views/MeasuringView')
  },
  {
    path: '/secondhand',
    name: 'secondhand',
    meta:{title:"二手仪器",isShow:true},
    component: () => import(/* webpackChunkName: "about" */ '../views/SecondHand')
  },
  {
    path: '/subscribe',
    name: 'subscribe',
    meta:{title:"预约试机",isShow:true},
    component: () => import(/* webpackChunkName: "about" */ '../views/SubscribeView')
  },
  {
    path: '/login',
    name: 'login',
    meta:{title:"登录",isShow:true},
    component: () => import(/* webpackChunkName: "about" */ '../views/LoginView')
  },
  {
    path: '/addgoods',
    name: 'addGoods',
    meta:{title:"添加产品",isShow:false},
    component: () => import(/* webpackChunkName: "about" */ '../views/addGoods')
  },
  {
    path: '/myorder',
    name: 'myOrder',
    meta:{isShow:true},
    component: () => import(/* webpackChunkName: "about" */ '../views/myOrder'),
    children:[
      {
        path: '/myorder',
        redirect:'/myOrderList'
      },
        {
      path:'/deliveryAddress',
      name:'deliveryAddress',
      meta:{title:"收货地址",isShow:true},
      component:()=>import('../components/myOrder/DeliveryAddress')
    },{
      path:'/myOrderList',
      name:'myOrderList',
      meta:{title:"我的订单",isShow:true},
      component:()=>import('../components/myOrder/myOrderList')
    }]
  },
  {
    path: '/sureorder',
    name: 'SureOrder',
    meta:{title:"我的订单",isShow:true},
    component: () => import(/* webpackChunkName: "about" */ '../views/SureOrder')
  },
  {
    path: '/payway',
    name: 'payWay',
    meta:{title:"付款方式",isShow:true},
    component: () => import(/* webpackChunkName: "about" */ '../views/payWay')
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to,from,next)=>{//beforeEach是router的钩子函数，在进入路由前执行
  // console.log(to,from)
  if(to.meta.title){//判断是否有标题
    document.title = to.meta.title
  }
  if(to.name=='myOrderList' || to.name=='deliveryAddress'){
    if(localStorage.getItem('Authorization')==null){
     next('/login')
    }
  }
  if(to.meta.title!='付款方式'&&from.name=='payWay'){
    next('/payway')
    // console.log(22222)
  }
  next()  //执行进入路由，如果不写就不会进入目标页
})

export default router
